import { createSlice } from "@reduxjs/toolkit";

import { changeRowDataRecourse } from "../utils";

const initialState = {
	headerData: {},
	tableData: [],
	fetchStatus: null,
	fetchStatusText: null,
	editorMode: "",
	undoActions: [],
	redoActions: [],
	modalVisible: { deleteConfirm: false, settings: false, projectTree: false, calcBook: false },
};

export const ssrEditorSlice = createSlice({
	name: "ssrEditor",
	initialState,
	reducers: {
		setHeaderData: (state, { payload }) => {
			state.headerData = payload;
		},
		setTableData: (state, { payload }) => {
			state.tableData = payload;
		},
		setFetchStatus: (state, { payload }) => {
			state.fetchStatus = payload;
		},
		setFetchStatusText: (state, { payload }) => {
			state.fetchStatusText = payload;
		},
		setEditorMode: (state, { payload }) => {
			state.editorMode = payload;
		},
		setUndoActions: (state, { payload }) => {
			state.undoActions = payload;
		},
		setRedoActions: (state, { payload }) => {
			state.redoActions = payload;
		},
		setModalVisible: (state, { payload }) => {
			state.modalVisible = { ...state.modalVisible, ...payload };
		},
		setCacheJson: (state, { payload }) => {
			state.headerData = payload.header_data;
			state.tableData = payload.table_data;
			state.undoActions = payload.actions_data;
			state.redoActions = payload.redo_data;
			state.fileLinksMap = payload.file_links_map;
			state.visibleSettings = payload.visible_settings;
		},
		changeRowData: (state, { payload: { rowKey, callback } }) => {
			state.tableData = changeRowDataRecourse(state.tableData, rowKey, callback);
		},
	},
});

export const { actions: ssrEditorActions, reducer: ssrEditorReducer } = ssrEditorSlice;
